function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Trac\\xE9_1015",
  "data-name": "Trac\\xE9 1015",
  d: "M123.712,415.788,121,418.5l1.329,1.328L126.157,416l2-2,8.712-8.712,1.479-1.478L143,399.157l-1.329-1.329-4.694,4.694-1.528,1.529L125.5,414ZM125,402h9.671l-2,2H125a2,2,0,0,0-2,2v6a1.989,1.989,0,0,0,.431,1.24l-1.419,1.419A3.982,3.982,0,0,1,121,412v-6A4,4,0,0,1,125,402Zm10,12h-4.014l-2,2H135a4,4,0,0,0,4-3.818L143,415V403l-3.425,2.411L137,407.986V412A2,2,0,0,1,135,414Zm4-4.261,2,1.408v-4.293l-2,1.407Z",
  transform: "translate(-121 -397.828)",
  fill: "current",
  fillRule: "evenodd"
});

function SvgCameraOff(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraOff);
export default __webpack_public_path__ + "static/media/camera-off.7851ce48.svg";
export { ForwardRef as ReactComponent };